import React from "react";

const FrontendModeContext = React.createContext();

export default FrontendModeContext;
